var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Iconly_Bold_Star",
    "data-name": "Iconly/Bold/Star",
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.116,
    height: 10.56,
    viewBox: "0 0 11.116 10.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Star",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42123",
    "data-name": "Path 42123",
    d: "M8.847,6.569a.612.612,0,0,0-.177.539l.494,2.734a.6.6,0,0,1-.25.6.612.612,0,0,1-.65.044L5.8,9.2a.628.628,0,0,0-.278-.073H5.373a.451.451,0,0,0-.15.05L2.761,10.47a.649.649,0,0,1-.395.061.618.618,0,0,1-.495-.706l.495-2.734a.622.622,0,0,0-.177-.544L.183,4.6a.6.6,0,0,1-.149-.628.624.624,0,0,1,.494-.417l2.762-.4a.618.618,0,0,0,.489-.338L5,.322a.578.578,0,0,1,.111-.15l.05-.039A.373.373,0,0,1,5.246.061L5.307.039,5.4,0h.234a.622.622,0,0,1,.489.333L7.357,2.818a.618.618,0,0,0,.461.338l2.762.4a.63.63,0,0,1,.506.417.6.6,0,0,1-.161.628Z",
    transform: "translate(0 0)",
    fill: "#dadce0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStar);
export default __webpack_public_path__ + "static/media/emptyStar.4af17ed3246e21401dba8febf60595e6.svg";
export { ForwardRef as ReactComponent };